import React from "react";
import { Link } from "react-router-dom";

function fmtDate(d) {
  if (!d) return "";
  const date = new Date(d);
  return isNaN(date) ? "" : date.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

export default function ViewMoreArticlesFunc({ viewMoreArticles = [] }) {
  if (!Array.isArray(viewMoreArticles) || viewMoreArticles.length === 0) {
    return null;
  }

  return (
    <div className="w-full bg-gray-200 py-8 px-16">
      <h2 className="text-xl font-semibold">Fler nyheter</h2>
      <ul className="mt-4">
        {viewMoreArticles.map((a) => {
          const title = a.title || a.name;
          const slug = a.slug || a.link;
          const date = a.updatedAt || a.createdAt || a.raw?.updatedAt || a.raw?.createdAt;

          if (!title || !slug) return null;

          return (
            <li className="list-none mt-4 pb-4 border-b border-gray-300" key={slug}>
              <Link className="flex items-start hover:underline" to={`/nyheter/${slug}`}>
                <div className="ml-0">
                  <h4 className="font-medium">{title}</h4>
                  {date && (
                    <p className="text-sm text-gray-600 mt-1">
                      {fmtDate(date)}
                    </p>
                  )}
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
